module.exports = function (
    value = "",
    is_can_update = false,
    can_update_field_names = [],
    cant_update_field_names = []
) {
    /*
        更新全運單欄位 :is_can_update="true"
        反轉，只更新運單部份欄位
            :is_can_update="true"
            :can_update_field_names="['number', '...']"
        更新運單但鎖部份欄位
            :is_can_update="true"
            :cant_update_field_names="['number', '...']"

        can_update_field_names > cant_update_field_names
    */

    if (value == "") {
        return false ;
    }

    if (!is_can_update) {
        return false ;
    }

    if (is_can_update && !can_update_field_names.length && !cant_update_field_names.length) {
        return true ;
    }

    if (can_update_field_names.length) {
        var reslut = _.findIndex(can_update_field_names, function(name) {
            return name == value
        });
        return (reslut == "-1") ? false : true;
    }

    if (cant_update_field_names.length) {
        var reslut = _.findIndex(cant_update_field_names, function(name) {
            return name == value
        });
        return (reslut == "-1") ? true : false;
    }

    return false ;
}
